(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/buy-stop-selector/assets/javascripts/buy-stop-selector.js') >= 0) return;  svs.modules.push('/components/marketplace/buy-stop-selector/assets/javascripts/buy-stop-selector.js');
'use strict';

const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;
const resolveDateBefore = (date, dateBefore) => formatDate(new Date(date - dateBefore), true, true);
const BuyStopSelector = _ref => {
  let className = _ref.className,
    drawCloseTime = _ref.drawCloseTime,
    maxValue = _ref.maxValue,
    onChange = _ref.onChange,
    value = _ref.value,
    options = _ref.options,
    label = _ref.label;
  const minuteOptions = options.filter(item => item.label.toLowerCase().indexOf('min') !== -1);
  const hoursOptions = options.filter(item => item.label.toLowerCase().indexOf('tim') !== -1);
  const daysOptions = options.filter(item => item.label.toLowerCase().indexOf('dag') !== -1);
  return React.createElement(React.Fragment, null, React.createElement("label", {
    className: "buy-stop-selector-label f-uppercase",
    htmlFor: "buy-stop-select"
  }, label), React.createElement("div", {
    className: "buy-stop-selector select-label"
  }, React.createElement("select", {
    className: "select select-default ".concat(className),
    "data-testid": "select-buy-stop",
    id: "buy-stop-select",
    onChange: e => {
      onChange(parseInt(e.target.value, 10));
    },
    value: "".concat(value)
  }, React.createElement("optgroup", null, minuteOptions.map(_ref2 => {
    let minutes = _ref2.minutes,
      label = _ref2.label;
    return React.createElement("option", {
      "data-testid": "select-buy-stop-option",
      disabled: minutes > maxValue,
      key: minutes,
      value: minutes
    }, label + (drawCloseTime ? " (".concat(resolveDateBefore(new Date(drawCloseTime).getTime(), minutes * 60 * 1000), ")") : ''));
  })), React.createElement("optgroup", null, hoursOptions.map(_ref3 => {
    let minutes = _ref3.minutes,
      label = _ref3.label;
    return React.createElement("option", {
      disabled: minutes > maxValue,
      key: minutes,
      value: minutes
    }, label + (drawCloseTime ? " (".concat(resolveDateBefore(new Date(drawCloseTime).getTime(), minutes * 60 * 1000), ")") : ''));
  })), React.createElement("optgroup", null, daysOptions.map(_ref4 => {
    let minutes = _ref4.minutes,
      label = _ref4.label;
    return React.createElement("option", {
      disabled: minutes > maxValue,
      key: minutes,
      value: minutes
    }, label + (drawCloseTime ? " (".concat(resolveDateBefore(new Date(drawCloseTime).getTime(), minutes * 60 * 1000), ")") : ''));
  })))));
};
BuyStopSelector.defaultProps = {
  className: '',
  label: 'SISTA ANDELSKÖP'
};
setGlobal('svs.components.marketplace.buyStopSelector.BuyStopSelector', BuyStopSelector);

 })(window);